import React from "react";
import { Lock } from "lucide-react";
import { cn } from "@/lib/utils";

interface LockableFieldLabelProps {
  title: string;
  isLocked: boolean;
  className?: string;
}

export const LockableFieldLabel: React.FC<LockableFieldLabelProps> = ({ title, isLocked, className }) => {
  return (
    <span className={cn("inline-flex items-center gap-1.5", className)}>
      {title}
      {isLocked && <Lock className="size-3.5 shrink-0 text-black" aria-hidden />}
    </span>
  );
};
